import React, {FC} from "react"
import {H2, H4, Label} from "@irati/ui/src/Typography"
import {FormattedCurrency, FormattedMessage} from "@irati/utils/lang"
import Flex from "@irati/ui/src/Flex"
import TreatsTriggerModal from "@irati-web/wallet/src/components/TreatsModal/TreatsTriggerModal"

import RewardsTriggerModal from "@irati-web/wallet/src/components/RewardsModal/RewardsTriggerModal"
import {useDeal} from "@irati/deals/hooks"
import Loading from "@irati/ui/src/Loading"
import {AvailableBalance} from "./styled/StyledSection"

export const PointsPaymentInfo: FC = () => {
  const dealInfo = useDeal({fetchPolicy: "cache-and-network"})

  return (
    <Loading useLoader={false} load={dealInfo.load}>
      <Flex direction="column" alignItems="center" marginBottom={2}>
        <H4 marginBottom={2}>
          <FormattedMessage id="perks.TTDeal.yourPerkboxWallet" />
        </H4>
        <AvailableBalance>
          <Label>
            <FormattedMessage id="perks.TTDeal.available" />
          </Label>
          <Flex>
            <H2>
              <FormattedCurrency value={dealInfo.walletForDeal?.amount || 0} currency={dealInfo.walletForDeal?.currency} />
            </H2>
            {dealInfo.isTTDeal && <TreatsTriggerModal />}
            {dealInfo.isRewardDeal && <RewardsTriggerModal />}
          </Flex>
        </AvailableBalance>
      </Flex>
    </Loading>
  )
}
